import { schema } from 'normalizr';
import {
  entitiesSelectorList,
  entitiesSelectorItem,
} from '../utils/asyncHelpers';

const schemaEntity = new schema.Entity('legalEntityContact');

export const getLegalEntityContacts = entitiesSelectorList(schemaEntity);
export const getLegalEntityContact = entitiesSelectorItem(schemaEntity);
export default schemaEntity;
